import React from "react";

const ProductInfo = (props) => {
  const { margin, title, tableWidth = "w-[142.5px]", productData } = props;

  return (
    <div className={`${margin}`}>
      <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
        {title}
      </div>
      <div className="flex w-full">
        <div className="flex w-[50%]">
          <h1
            className={`flex-none border py-2 ${tableWidth} px-4 border-r-0 border-disable-grey bg-input-grey`}
          >
            카테고리
          </h1>
          <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
            {productData?.productGroup?.productGroupCategory?.name}
          </div>
        </div>
        <div className="flex w-[50%]">
          <h1 className="flex-none border py-2 w-40 px-4 border-r-0 border-disable-grey bg-input-grey">
            REF(상품코드)
          </h1>
          <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
            {productData?.ref}
          </div>
        </div>
      </div>
      <div className="flex w-full">
        <h1 className="flex-none border border-t-0 py-2 w-[142.5px] px-4 border-r-0 border-disable-grey bg-input-grey">
          상품 그룹명
        </h1>
        <div className="flex flex-none items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
          {productData?.productGroup?.name}
        </div>
      </div>
      <div className="flex w-full">
        <h1 className="flex-none border border-t-0 py-2 w-[142.5px] px-4 border-r-0 border-disable-grey bg-input-grey">
          상품명
        </h1>
        <div className="flex flex-none items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
          {productData?.name}
        </div>
      </div>
    </div>
  );
};

export default ProductInfo;
